import { ADD_BANK_ENTRIES, ARCHIVE_BANK_ENTRY } from '@instructure/quiz-common';
export var addBankEntries = function addBankEntries(bankEntries) {
  return {
    type: ADD_BANK_ENTRIES,
    payload: bankEntries
  };
};
export var archiveBankEntry = function archiveBankEntry(bankEntryId) {
  return {
    type: ARCHIVE_BANK_ENTRY,
    payload: bankEntryId
  };
};